import Vue from 'vue'
import Base from '@/layouts/base'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'


// --------------
//  SimpleGoogleAutocomplete setup
// --------------

import SimpleGoogleAutocomplete from './components/inputs/SimpleGoogleAutocomplete'
Vue.use(SimpleGoogleAutocomplete, {
  apiKey: process.env.VUE_APP_GOOGLE_MAPS_KEY,
  // version: '...', // Optional
  // language: '...', // Optional
  installComponents: true, // Optional (default: true) - false, if you want to locally install components
  vueGoogleMapsCompatibility: false, // Optional (default: false) - true, requires vue2-google-maps to be configured see https://github.com/xkjyeah/vue-google-maps
})

// --------------
// vue-chart-3 setup
// --------------

import { Chart, registerables } from "chart.js";
import VComp from "@vue/composition-api"
Chart.register(...registerables)
Vue.use(VComp)

// --------------
// VueMask setup
// --------------

import VueMask from 'v-mask'
Vue.use(VueMask)

Vue.config.productionTip = false

var oldLog = console.log;
console.log = function( ...items ) {
  // Call native method first  
  oldLog.apply(this,items)
  store.commit('console/APPEND', items)
}

// --------------
// Leaflet setup
// --------------

import '@/assets/global.css'
import 'leaflet/dist/leaflet.css'

// fix webpack issues with leaflet
import {  Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

// --------------
// vue-signature-pad
// --------------

import VueSignaturePad from 'vue-signature-pad'
Vue.use(VueSignaturePad)

// --------------
// Google Auth
// --------------

// import GAuth from 'vue-google-oauth2'

// const gauthOption = {
//   clientId: '930982954955-qqki20lq9bbrbeg9qspn0ss0rnfm1a6t.apps.googleusercontent.com',
//   scope: 'profile email',
//   prompt: 'select_account'
// }
// Vue.use(GAuth, gauthOption)


new Vue({
  router,
  store,
  vuetify,
  render: h => h(Base)
}).$mount('#app')
